import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['LocalBusiness', 'ProfessionalService'],
      '@id': `${siteUrl}/#localbusiness`,
      name: '(주)소담이앤씨',
      alternateName: '소담이앤씨',
      description:
        '석면조사부터 해체·제거, 안전관리까지 18년 경력으로 한 번에 책임지는 한번에 맺음이 있는 석면전문기업 (주)소담이앤씨. 경기도 화성시 석면해체·제거, 석면조사, 농도측정, 감리 전문기업.',
      url: `${siteUrl}/`,
      telephone: '031-8043-8611',
      faxNumber: '031-8043-9211',
      email: 'sodamenc0728@daum.net',
      priceRange: '문의',
      founder: {
        '@type': 'Person',
        name: '곽연숙',
      },
      taxID: '443-88-03390',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '만세구 꽃내음1길 5-4, 510호',
        addressLocality: '화성시',
        addressRegion: '경기도',
        postalCode: '18531',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.1951,
        longitude: 126.8317,
      },
      hasMap: 'https://maps.google.com/?q=37.1951,126.8317',
      areaServed: [
        {
          '@type': 'Country',
          name: '대한민국',
        },
        {
          '@type': 'AdministrativeArea',
          name: '경기도',
        },
        {
          '@type': 'City',
          name: '화성시',
        },
      ],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '031-8043-8611',
          contactType: 'customer service',
          areaServed: 'KR',
          availableLanguage: 'Korean',
          contactOption: 'TollFree',
          hoursAvailable: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
        },
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
      knowsAbout: [
        '석면해체제거',
        '석면조사',
        '석면농도측정',
        '석면감리',
        '석면안전관리',
        '건축물석면조사',
        '슬레이트철거',
        '축사석면철거',
        '창고슬레이트철거',
        '석면위해성평가',
        '석면폐기물처리',
      ],
      serviceArea: {
        '@type': 'GeoCircle',
        geoMidpoint: {
          '@type': 'GeoCoordinates',
          latitude: 37.1951,
          longitude: 126.8317,
        },
        geoRadius: '200000',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: '석면 전문 서비스',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '석면해체·제거',
              description: '석면이 포함된 건축 자재를 안전하게 해체하고 제거하는 전문 서비스',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '석면조사',
              description: '건축물 해체·철거·개보수 전 법적 의무 석면조사 서비스',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '석면농도측정',
              description: '작업 현장의 석면 농도를 측정하고 안전 기준 준수 여부를 확인하는 서비스',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '석면감리',
              description: '석면해체제거 작업의 적법성과 안전성을 감독하는 전문 감리 서비스',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '슬레이트 철거',
              description: '축사·창고·주택의 슬레이트 지붕 석면 안전 철거 서비스',
            },
          },
        ],
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: '(주)소담이앤씨',
      description: '경기도 화성시 석면해체·제거·조사 전문기업',
      inLanguage: 'ko-KR',
      publisher: {
        '@id': `${siteUrl}/#localbusiness`,
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: '(주)소담이앤씨 | 석면해체제거·석면조사 전문기업',
      description:
        '석면조사부터 해체·제거, 안전관리까지 18년 경력으로 한 번에 책임지는 한번에 맺음이 있는 석면전문기업 (주)소담이앤씨. 경기도 화성시 석면해체·제거, 석면조사, 농도측정, 감리 전문기업.',
      inLanguage: 'ko-KR',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#localbusiness` },
      dateModified: '2026-04-06',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '홈',
            item: `${siteUrl}/`,
          },
        ],
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '석면해체제거 작업은 어떻게 진행되나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '석면조사 → 작업 계획 수립 → 주민·건물 사용자 고지 → 석면해체·제거 작업 → 폐기물 처리 → 잔재물 확인 검사 순으로 진행됩니다. 모든 과정은 환경부 허가 기관인 소담이앤씨가 책임집니다.',
          },
        },
        {
          '@type': 'Question',
          name: '석면조사는 언제 필요한가요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '건축물 해체·철거·개·보수 전에 반드시 석면조사가 필요합니다. 건축물 연면적 200㎡ 이상이거나 주택 해체 시 의무적으로 공인 기관의 석면조사가 필요합니다.',
          },
        },
        {
          '@type': 'Question',
          name: '경기도 화성시 외 지역도 석면해체제거 서비스가 가능한가요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '네, 소담이앤씨는 경기도 화성시를 기반으로 전국 현장에서 석면해체제거, 석면조사, 감리, 안전관리 서비스를 제공합니다.',
          },
        },
        {
          '@type': 'Question',
          name: '슬레이트 지붕 철거도 가능한가요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '네, 소담이앤씨는 축사, 창고, 주택의 슬레이트 지붕 철거 전문 서비스를 제공합니다. 슬레이트에는 석면이 포함되어 있어 반드시 전문 업체에 의뢰해야 하며, 저희는 환경부 허가를 받은 전문 기관으로 안전하게 처리해 드립니다.',
          },
        },
        {
          '@type': 'Question',
          name: '석면 폐기물은 어떻게 처리되나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '석면 폐기물은 환경부 지정 석면폐기물 처리 기준에 따라 밀봉·포장 후 지정 폐기물 처리업체를 통해 합법적으로 처리됩니다. 소담이앤씨는 석면 폐기물 처리의 전 과정을 투명하게 관리합니다.',
          },
        },
      ],
    },
  ],
};

export default function SchemaOrg() {
  useEffect(() => {
    const existingScript = document.getElementById('schema-org-ld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-org-ld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(homeSchema);
    document.head.appendChild(script);

    return () => {
      document.getElementById('schema-org-ld')?.remove();
    };
  }, []);

  return null;
}
